import { useDecision } from '@optimizely/react-sdk';

import { FeatureFlags, NotificationsVariables } from '@frontend/constants/featureFlags';

export function useNotificationFeatures() {
  const [decision] = useDecision(FeatureFlags.NOTIFICATIONS);
  const vars = decision?.variables;
  return {
    groupingEnabled: Boolean(vars?.[NotificationsVariables.GROUPING]),
    badgeEnabled: Boolean(vars?.[NotificationsVariables.BADGE_COUNT]),
  };
}
